import React from "react";
import TeamTitle from "../../components/title/TeamTitle";
import { CardBody, CardContainer, CardFooter, CardHeader } from "best-common-react";
import DepartmentEditBody from "../../components/department/edit/DepartmentEditBody";
import DepartmentEditFooter from "../../components/department/edit/DepartmentEditFooter";
import GlobalProtected from "../../components/protected/GlobalProtected";
import DepartmentEditContainerHeader from "../../components/department/edit/DepartmentEditContainerHeader";

class DepartmentEditContainer extends React.Component {
  render() {
    return (
      <div>
        <TeamTitle disabled={true} />
        <CardContainer>
          <CardHeader>
            <DepartmentEditContainerHeader />
          </CardHeader>
          <CardBody>
            <DepartmentEditBody />
          </CardBody>
          <CardFooter>
            <DepartmentEditFooter />
          </CardFooter>
        </CardContainer>
      </div>
    );
  }
}

export default GlobalProtected(DepartmentEditContainer);
